// TODO Make this less hacky, and more robust.
const currentDomain = (location) => {
    //if location origin starts with localhost, return localhost:3001
    if (location.origin.startsWith('http://localhost') || location.origin.startsWith('http://127.0.0.1')) {
      return 'http://localhost:3001';
    } else {
      return location.origin;
    }
}

export default currentDomain;

